export default () =>
  new Promise((resolve, reject) => {
    window.axios
      .get(`${process.env.VUE_APP_API_ADMIN_LOCATION}permissions`, {
        headers: {
          ignoreLoading: true,
        },
      })
      .then(({ data }) => {
        let setting = {};
        if (data) {
          setting = data.data;
        }
        resolve(setting);
      })
      .catch((error) => {
        reject(error);
      });
  });
